import { render } from "./Banner.vue?vue&type=template&id=343d5d3c&scoped=true&ts=true"
import script from "./Banner.vue?vue&type=script&lang=ts"
export * from "./Banner.vue?vue&type=script&lang=ts"

import "./Banner.vue?vue&type=style&index=0&id=343d5d3c&lang=scss&scoped=true"

import exportComponent from "../../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343d5d3c"]])

export default __exports__